import jwtDecode from 'jwt-decode';
import processPost from '../utils/helpers/apiClient';
import store from '../redux/store';
import { ActionTypes } from '../redux/constants/action-types';
import {
  REQUEST_HOST,
  FLEX_REQUEST_URL,
  POST_VERB,
  ENCRYPTION_TYPE_RSAOAEP,
  RISK_SETUP_REQUEST_URL,
  RISK_AUTHENTICATION_ENROLL_CHECK_URL,
  AUTH_SUCCESSFUL_STATUS,
  CONSUMER_AUTH_REQUIRED_REASON_CODE,
  RISK_AUTHENTICATION_RESULT_URL
} from '../config/constants';
import generateRandom from '../utils/helpers/utll';
import merchantConfig from '../config/merchantConfig';
// =========== W A R N I N G =============
// The request to CYBS REST API is being made from client-side solely for demo purposes.
// If there is a back-end, replace this direct call (client-side call to CYBS REST API) with a front-end call to the back-end,
// which subsequently integrates with CYBS REST API.
// =======================================
const fetchCaptureContext = async () => {
  processPost(
    REQUEST_HOST,
    FLEX_REQUEST_URL,
    POST_VERB,
    {
      encryptionType: ENCRYPTION_TYPE_RSAOAEP,
      targetOrigin: `${window.location.protocol}//${window.location.host}`
    },
    (error, metaData, returnObject, _status) => {
      if (_status >= 0) {
        store.dispatch({
          type: ActionTypes.SET_CONSOLE_LOG_VALUE,
          payload: { returnObject, stage: 1 }
        });
        store.dispatch({
          type: ActionTypes.UPDATE_RUN_SEQUENCE,
          payload: 1
        });
      }
    }
  );
};

const getStaticRequestResponse = async (
  stage,
  requestResponseXFPath,
  xfRootPath,
  challengeCardChoosed,
  demoToolType
) => {
  fetch(xfRootPath.concat(requestResponseXFPath))
    .then((result) => result.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const textComponents = doc.getElementsByClassName(
        'text parbase aem-GridColumn aem-GridColumn--default--12'
      );
      let returnObject = {};
      for (let element of textComponents) {
        if (
          element.getElementsByClassName('request-title').length >= 1 &&
          element.getElementsByClassName('request-body').length >= 1
        ) {
          returnObject.request = {};
          returnObject.request.title = element.getElementsByClassName('request-title')[0].innerText;
          returnObject.request.body = getValidJsonWithSubmiTimeUTC(
            element.getElementsByClassName('request-body')[0].innerText
          );
        }
        if (
          element.getElementsByClassName('response-title').length >= 1 &&
          element.getElementsByClassName('response-body').length >= 1
        ) {
          returnObject.response = {};
          returnObject.response.title =
            element.getElementsByClassName('response-title')[0].innerText;
          returnObject.response.body = getValidJsonWithSubmiTimeUTC(
            element.getElementsByClassName('response-body')[0].innerText
          );
        }
        if (
          element.getElementsByClassName('decoded-response-title').length >= 1 &&
          element.getElementsByClassName('decoded-response-body').length >= 1
        ) {
          returnObject.decodedResponse = {};
          returnObject.decodedResponse.title =
            element.getElementsByClassName('decoded-response-title')[0].innerText;
          returnObject.decodedResponse.value = getValidJsonWithSubmiTimeUTC(
            element.getElementsByClassName('decoded-response-body')[0].innerText
          );
        }
      }

      if (returnObject.response === undefined) {
        returnObject.response = {};
        returnObject.response.title = '';
        returnObject.response.body = undefined;
      }
      store.dispatch({
        type: ActionTypes.SET_CONSOLE_LOG_VALUE,
        payload: { returnObject, stage: stage }
      });
      store.dispatch({
        type: ActionTypes.UPDATE_RUN_SEQUENCE,
        payload: stage
      });
      store.dispatch({
        type: ActionTypes.UPDATE_CURRENT_STAGE,
        payload: stage + 1
      });
      if (
        (demoToolType === 'microformWithPayerAuth' && challengeCardChoosed && stage === 7) ||
        (demoToolType === 'microformWithPayerAuth' && !challengeCardChoosed && stage === 5) ||
        (demoToolType === 'microformOnly' && stage === 2)
      ) {
        store.dispatch({
          type: ActionTypes.TOGGLE_START_OVER_CALLOUT,
          payload: true
        });
      }
    });
};

const setupPayerAuth = async () => {
  const { logReducer } = store.getState();
  const microformStageLog = logReducer.logStages.find((stage) => {
    if (stage.stage === 2) return stage;
    return undefined;
  });
  const decodedData = microformStageLog.request.value;
  processPost(
    REQUEST_HOST,
    RISK_SETUP_REQUEST_URL,
    POST_VERB,
    {
      clientReferenceInformation: {
        code: generateRandom()
      },
      paymentInformation: {
        card: {
          type: decodedData.data.type,
          expirationMonth: decodedData.data.expirationMonth,
          expirationYear: decodedData.data.expirationYear
        }
      },
      tokenInformation: {
        transientToken: decodedData.jti
      }
    },
    (error, metaData, returnObject, _status) => {
      if (_status >= 0) {
        const decodedResponse = jwtDecode(
          returnObject.response.body.consumerAuthenticationInformation.accessToken
        );
        const newReturnObject = {
          ...returnObject,
          decodedResponse: {
            value: decodedResponse,
            title: 'device data collection decoded jwt payload'
          }
        };
        store.dispatch({
          type: ActionTypes.SET_CONSOLE_LOG_VALUE,
          payload: { returnObject: newReturnObject, stage: 3 }
        });
        store.dispatch({
          type: ActionTypes.UPDATE_RUN_SEQUENCE,
          payload: 3
        });
      }
    }
  );
};

const enrollPayerAuth = async () => {
  const { logReducer } = store.getState();
  const microformStageLog = logReducer.logStages.find((stage) => {
    if (stage.stage === 2) return stage;
    return undefined;
  });
  const deviceCollectionStageLog = logReducer.logStages.find((stage) => {
    if (stage.stage === 4) return stage;
    return undefined;
  });
  if (microformStageLog !== undefined && deviceCollectionStageLog !== undefined) {
    const payload = merchantConfig({
      jti: microformStageLog.request.value.jti,
      SessionId: deviceCollectionStageLog.request.value.SessionId
    });
    processPost(
      REQUEST_HOST,
      RISK_AUTHENTICATION_ENROLL_CHECK_URL,
      POST_VERB,
      payload,
      (error, metaData, returnObject, _status) => {
        if (_status >= 0) {
          store.dispatch({
            type: ActionTypes.SET_CONSOLE_LOG_VALUE,
            payload: { returnObject, stage: 5 }
          });
          if (returnObject.response.body.status === AUTH_SUCCESSFUL_STATUS) {
            store.dispatch({
              type: ActionTypes.TOGGLE_START_OVER_CALLOUT,
              payload: true
            });
          } else if (
            returnObject.response.body.errorInformation &&
            returnObject.response.body.errorInformation.reason ===
              CONSUMER_AUTH_REQUIRED_REASON_CODE
          ) {
            store.dispatch({
              type: ActionTypes.UPDATE_RUN_SEQUENCE,
              payload: 5
            });
          }
        }
      }
    );
  }
};

const validatePaAuth = async () => {
  const { logReducer } = store.getState();
  const consumerAuthenticationStage = logReducer.logStages.find((stage) => {
    if (stage.stage === 6) return stage;
    return undefined;
  });

  if (consumerAuthenticationStage !== undefined) {
    const payload = {
      clientReferenceInformation: {
        code: generateRandom()
      },
      consumerAuthenticationInformation: {
        authenticationTransactionId: consumerAuthenticationStage.request.value.TransactionId
      }
    };
    processPost(
      REQUEST_HOST,
      RISK_AUTHENTICATION_RESULT_URL,
      POST_VERB,
      payload,
      (error, metaData, returnObject, _status) => {
        if (_status >= 0) {
          store.dispatch({
            type: ActionTypes.SET_CONSOLE_LOG_VALUE,
            payload: { returnObject, stage: 7 }
          });
          if (returnObject.response.body.status === AUTH_SUCCESSFUL_STATUS) {
            store.dispatch({
              type: ActionTypes.TOGGLE_START_OVER_CALLOUT,
              payload: true
            });
          }
          store.dispatch({
            type: ActionTypes.UPDATE_RUN_SEQUENCE,
            payload: 7
          });
        }
      }
    );
  }
};

const getValidJsonWithSubmiTimeUTC = (data) => {
  try {
    let json = JSON.parse(data);
    if (json.submitTimeUtc) {
      let utcDate = new Date().toISOString().split('.')[0] + 'Z';
      json.submitTimeUtc = utcDate;
    }
    return json;
  } catch {
    return data;
  }
};

export {
  fetchCaptureContext,
  getStaticRequestResponse,
  setupPayerAuth,
  enrollPayerAuth,
  validatePaAuth
};
